import React from 'react';
import { Avatar } from 'src/components/atoms';
import { getInitials } from 'src/utils/getInitials';
import {
  StyledBadge,
  StyledTd,
  UserDescription,
  UserInformationRowStyled,
  UserName,
} from './UserInformationRow.styles';

interface Props {
  name: string;
  description: string;
  badgeText: string;
  'data-testid'?: string;
  badgeWidth?: string;
  isRowEnabled?: boolean;
  onClick?: React.MouseEventHandler;
}

export const UserInformationRow = ({
  name,
  description,
  badgeText,
  badgeWidth = '85px',
  onClick,
  ...props
}: Props) => (
  <UserInformationRowStyled
    {...props}
    onClick={onClick}
    title={`${name} | ${description} | ${badgeText}`}
  >
    <StyledTd width="55px">
      <Avatar text={getInitials(name)} variant="text" size="small" />
    </StyledTd>
    <StyledTd width="50%">
      <UserName data-testid={`${props['data-testid']}-name`}>{name}</UserName>
    </StyledTd>
    <StyledTd width="50%">
      <UserDescription data-testid={`${props['data-testid']}-description`}>
        {description}
      </UserDescription>
    </StyledTd>
    <StyledTd width={badgeWidth}>
      <StyledBadge
        variant="draft"
        text={badgeText}
        data-testid={`${props['data-testid']}-badge`}
      />
    </StyledTd>
  </UserInformationRowStyled>
);
